import React, { Fragment, useMemo } from "react";
import styled from "styled-components";
import { View, Text, Link, SlideImage, Divider } from "./components";
import { graphql } from "react-apollo";
import { compose } from "recompose";
import tagAlbumsQuery from "./graphql/tagAlbumsQuery";
import friendlyUrl from "speakingurl";

import professions, { addToHairMakeUp, excludeFromMenu } from "./professions";

import ArtistsIndexMobile from "./ArtistsIndexMobile";

export const Container = styled(View).attrs(() => ({
  mb: 3,
}))`
  columns: 2;

  @media (min-width: 606px) {
    columns: 4;
  }
  page-break-inside: avoid;
  break-inside: avoid;
  column-gap: 50px;
`;

const ProfessionContainer = styled(View).attrs()`
  display: block;
  width: 100%;
  @media (min-width: 606px) {
    &:nth-child(1) {
      break-before: column;
    }
    &:nth-child(4) {
      break-before: column;
    }
    &:nth-child(7) {
      break-before: column;
    }
  }
  @media (max-width: 605px) {
    &:nth-child(3) {
      break-before: column;
    }
  }
  & hr {
    display: inline-block;
    min-width: 100%;
  }
`;

const ArtistLink = styled(Link).attrs(() => ({ color: "primary" }))`
  display: block;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover {
    opacity: 0.65;
  }
`;

function Artists(props) {
  const albums =
    "allTags" in props.data
      ? props.data.allTags.length > 0 && props.data.allTags[0].albums
      : null;
  const artistsByCategory = useMemo(() => {
    if (!albums) return [];
    return professions
      .filter((profession) => !excludeFromMenu.includes(profession))
      .map((profession, index) => ({
        name: profession,
        artists: albums.filter(
          (album) => {
            if (profession === "Talent") {
              return album.tags.find((tag) => tag.name === profession);
            } else {
              return (
                (album.tags.find(
                  (tag) =>
                    profession === "Hair & Make Up" &&
                    addToHairMakeUp.includes(tag.name)
                ) ||
                  album.tags.find((tag) => tag.name === profession)) &&
                !album.tags.find((tag) => tag.name === "Talent")
              );
            }
          }
          /* album.tags.find(
            tag =>
              tag.name ===
              profession &&
            (index === 0 ||
              index > 2 ||
              !album.tags.find(
                tag => tag.name === "Hair & Make Up"
              ))  // exclude when this artist already has hair&makeup as profession
          ) */
        ),
      }));
  }, [albums]);
  if (props.mobile)
    return <ArtistsIndexMobile my={4} artistsByCategory={artistsByCategory} />;

  return (
    <Container>
      {!props.mobile &&
        artistsByCategory.map((category) => (
          <ProfessionContainer key={category.name}>
            <Text textStyle="title" pt={3}>
              {category.name}
            </Text>
            <Divider mt={2} mb={2} />
            {category.artists.map((artist) => {
              const slide = artist.slides.length > 0 && artist.slides[0];
              const to = `/artist/${artist.slug.split("-bio")[0]}`;
              const artistName = artist.title.split(" - ")[0];

              const byProfession = !!artist.tags.find(
                (tag) => tag.name === "By Profession"
              );
              // const category = category && category.name
              return (
                <ArtistLink
                  to={`/artist/${artist.slug.split("-bio")[0]}${
                    category.name === "Make Up" ? `#make-up` : ""
                  }${
                    byProfession
                      ? `?profession=${friendlyUrl(
                          category.name.replace("&", "")
                        )}`
                      : ""
                  }`}
                  textStyle="label"
                  my={1}
                  key={artist.id}
                >
                  {/* <ImageContainer>
                  {artist.slides.length > 0 && (
                    <SlideImage slide={artist.slides[0]} />
                  )}
                  </ImageContainer> */}
                  {
                    artist.title
                      .split("Volkers")
                      .join("Völkers")
                      .split(" - ")[0]
                  }{" "}
                </ArtistLink>
              );
            })}
          </ProfessionContainer>
        ))}
    </Container>
  );
}

export default compose(
  graphql(tagAlbumsQuery, {
    options: () => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
          tagName: "Bio",
        },
      };
    },
  })
)(Artists);
